import {Controller} from "stimulus";
import navigationHelper from "../../assets/navigation-helper";
import {objectToFormData} from "../../assets/forms";

export default class extends Controller {
  connect() {
    this.poll();
  }

  poll() {
    fetch("/cart/index/ajax-completed/", {
      method: 'POST',
      body: objectToFormData({id: this.cart_id})
    })
      .then((response) => {
        switch (response.status) {
          case 200:
            return this.success();
          case 402:
            return this.paymentPending();
          case 400:
          case 404:
            return this.pollFailed();
          default:
            return this.serverError();
        }
      });
  }

  pollFailed() {
    navigationHelper.goto("/");
  }

  paymentPending() {
    setTimeout(() => this.poll(), 5000);
  }

  serverError() {
    // navigationHelper.reload();/**/
    console.error('servererror')
  }

  success() {
    navigationHelper.goto(`/cart/index/success/id/${this.cart_id}/`);
  }

  get cart_id() {
    return this.element.dataset.cartId || "";
  }
}
